import React, { Component } from 'react';

class Footer extends Component {

    render() {
        return (
            <div className='rakuten-footer'>
                このサイトは楽天株式会社が運営しています。|
                <span><a className='term-link' href='https://www.rakuten.co.jp/shops/manual/navi/rule/law/10_009.html'>利用規約</a></span>
            </div>);
    }


}

export default Footer;
